import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FacebookProductSetForm from '../../components/Facebook/FacebookProductSetForm';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['facebookProductSet']}`;

const FacebookProductSetDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();

  const [facebookProductSet, setFacebookProductSet] = useState();
  const [segments, setSegments] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId, facebookProductSetId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/productSets/${facebookProductSetId}`)
      .then(({ facebookProductSet }) => {
        if (!facebookProductSet) {
          navigate(`/accounts/${accountId}/domains/${domainId}/facebook/productSets`);
        }

        setFacebookProductSet(facebookProductSet);
      })
      .catch(setLoadError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments?scope=internal`)
      .then(({ segments }) => {
        setSegments(segments);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, facebookProductSetId]);

  const update = (facebookProductSet) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/productSets/${facebookProductSetId}`, {
      method: 'PUT',
      body: JSON.stringify(facebookProductSet),
    }).then(() => {
      navigate(`/accounts/${accountId}/domains/${domainId}/facebook/productSets`);
    });
  };

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/facebook/productSets/${facebookProductSet.id}`, {
      method: 'DELETE',
      body: JSON.stringify({}),
    }).then(() => {
      if (typeof cb === 'function') {
        cb();
      }
      navigate(`/accounts/${accountId}/domains/${domainId}/facebook/productSets`);
    });
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (facebookProductSet === undefined) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/facebook/productSets` },
    { title: facebookProductSet?.name || 'Unknown Facebook Product Set' },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${facebookProductSet?.name || 'Unknown Product Set'} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <FacebookProductSetForm
            facebookProductSet={facebookProductSet}
            segments={segments}
            saveFacebookProductSet={(facebookProductSet) => update(facebookProductSet)}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/facebook/productSets`)}
            deleteFacebookProductSet={(cb) => del(cb)}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default FacebookProductSetDetailsPage;
